import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { Interaction } from "three.interaction";
import $ from "jquery";
import * as TWEEN from "tween";
import pointsGenerator from "../model/pointsGenerator";

let container = document.getElementById('view');

let scene = new THREE.Scene();

let camera = new THREE.PerspectiveCamera(45, container.clientWidth / container.clientHeight, .1, 1000);
camera.position.set( 0, 0, 50 );

var renderer = new THREE.WebGLRenderer({
  antialias: true
});

renderer.setSize( container.clientWidth, container.clientHeight );
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;

container.append( renderer.domElement );

var controls = new OrbitControls( camera, renderer.domElement );
controls.minDistance = 10;
controls.maxDistance = 500;

// new a interaction, then you can add interaction-event with your free style
const interaction = new Interaction(renderer, scene, camera);

//

window.addEventListener( 'resize', oncontainerResize, false );

function oncontainerResize(){
    camera.aspect = container.clientWidth / container.clientHeight;
    camera.updateProjectionMatrix();

    renderer.setSize( container.clientWidth, container.clientHeight );
}

//
/* */

var circles = [];

let points = pointsGenerator(30, 30),
	area = 60,
	objFaces = 32;

var dirLight = new THREE.PointLight( 0xffffff, .4 );
dirLight.position.set( 0, area*3, 0 );
//dirLight.castShadow = true;
// dirLight.shadow.mapSize.width = 1024;
// dirLight.shadow.mapSize.height = 1024;
scene.add( dirLight );

var dirLight2 = new THREE.PointLight( 0xffffff, .5 );
dirLight2.position.set( -50, -200, -50 );
// dirLight2.shadow.mapSize.width = 1024;
// dirLight2.shadow.mapSize.height = 1024;
//dirLight2.castShadow = true;
scene.add( dirLight2 );

var elight = new THREE.HemisphereLight( 0x666666, 0xffffff, .3 );
scene.add( elight );

// FLOOR
// var loadera = new THREE.CubeTextureLoader();
// loadera.setCrossOrigin( "" );
// loadera.setPath( 'http://stemkoski.github.io/Three.js/images/' );

// var checkerTexture = loadera.load(['checkerboard.jpg']);

//var floorTexture = new THREE.ImageUtils.loadTexture( '' );
// checkerTexture.wrapS = checkerTexture.wrapT = THREE.RepeatWrapping; 
// checkerTexture.repeat.set( 10, 10 );
// var floorMaterial = new THREE.MeshBasicMaterial( { map: checkerTexture, side: THREE.DoubleSide } );
// var floorGeometry = new THREE.PlaneGeometry(1000, 1000, 10, 10);
// var floor = new THREE.Mesh(floorGeometry, floorMaterial);
// floor.position.y = -10;
// floor.rotation.x = Math.PI / 2;
// scene.add(floor);

var loadera = new THREE.TextureLoader();
loadera.setCrossOrigin("anonymous");
loadera.load(
  'https://live.staticflickr.com/1402/661008860_d018200f67_k.jpg',
  function do_something_with_texture(tex) {
  	// FLOOR
	//var floorTexture = new THREE.ImageUtils.loadTexture( tex );
	tex.wrapS = tex.wrapT = THREE.RepeatWrapping; 
	tex.repeat.set( 1, 1 );
	var floorMaterial = new THREE.MeshPhongMaterial( {
		color: '0x000000',
		map: tex,
		side: THREE.DoubleSide,
		shininess: 80
	} );
	var floorGeometry = new THREE.SphereGeometry( 200, 16, 16, 16 );//(400, 16); 
	var floor = new THREE.Mesh(floorGeometry, floorMaterial);
	floor.receiveShadow = true;
	floor.position.set(0, -300, 0);
	floor.rotation.x = Math.PI / 2;
	scene.add(floor);
  }
);

var loader = new THREE.CubeTextureLoader();
loader.setCrossOrigin( "" );
loader.setPath( 'https://threejs.org/examples/textures/cube/pisa/' );

// var cubeTexture = loader.load( [
//   'px.png', 'nx.png',
//   'py.png', 'ny.png',
//   'pz.png', 'nz.png'
// ] );

var cubeTexture = loader.load( [
  'px.png', 'nx.png',
  'py.png', 'ny.png',
  'pz.png', 'nz.png'
] );

// scene.background = cubeTexture;

/*function createBoxWithRoundedEdges( width, height, depth, radius0, smoothness ) {
  let shape = new THREE.Shape();
  let eps = 0.1;
  let radius = radius0 - eps;
  shape.absarc( eps, eps, eps, -Math.PI / 2, -Math.PI, true );
  shape.absarc( eps, height - radius * 2, eps, Math.PI, Math.PI / 2, true );
  shape.absarc( width - radius * 2, height -  radius * 2, eps, Math.PI / 2, 0, true );
  shape.absarc( width - radius * 2, eps, eps, 0, -Math.PI / 2, true );
  let geometry = new THREE.ExtrudeBufferGeometry( shape, {
    amount: depth - radius0 * 2,
    bevelEnabled: true,
    bevelSegments: smoothness * 2,
    steps: 1,
    bevelSize: radius,
    bevelThickness: radius0
  });
  
  geometry.center();
  
  return geometry;
}*/

for ( let i = 0; i < points.length; i++ ){

	let p = points[i];

	var coef = Math.random();
	var geometry = new THREE.SphereGeometry( p.r*area*0.5, objFaces, objFaces, objFaces );
	var material = new THREE.MeshPhongMaterial( {
		color: '#776147', //getRandomColor(), // 9 ? '#FF6600' : '#e0e0da',//getRandomColor(),
		shininess: 10,
		//flatShading: true
		//envMap: cubeTexture,
		//metalness: 1,//i / totalObjects,
		//roughness: 1//1 - i / totalObjects
		//side: THREE.DoubleSide
	} );
	var circle = new THREE.Mesh( geometry, material );
	circle.position.x = -area/2 + p.x * area;
	circle.position.y = -area/2 + p.y * area;

	circle.position.z = -area/2 + p.z * area;
	circle.name = "circle-" + i;
	//circle.castShadow = true; //default is false
	// circle.receiveShadow = false; //default

	scene.add( circle );

	circle.on('click', function(ev) {
		for (var circle of circles) {
			//circle.material.color.set( 0x776147 );
			circle.material.emissive.set( 0x000000 );
		}
		//this.material.color.set( 0xbf9d5b );
		this.material.emissive.set( 0xbf9d5b );
		focusOnObject(this);
		lightMove(this.matrixWorld);
	});

	circles.push(circle);
}

function lightMove(matrixWorld){
	let pos = new THREE.Vector3();
    pos.setFromMatrixPosition( matrixWorld );

	plight.position.copy( pos );
}

/*var planeGeometry = new THREE.PlaneGeometry( 1000, 1000, 1, 1 );
  var planeMaterial = new THREE.MeshPhongMaterial({
    color: 0x101b1f, side: THREE.DoubleSide})
  var plane = new THREE.Mesh( planeGeometry, planeMaterial );
  plane.position.z = -200;
  //plane.receiveShadow = true;
  scene.add( plane );*/


/*function getRandomColor() {
  var letters = '123456789ABCDEF';
  var color = '#00';
  var pair = '';
  for (var i = 0; i < 4; i++) {
  	//pair += letters[Math.floor(Math.random() * letters.length)];
    color += letters[Math.floor(Math.random() * letters.length)];
  }
  //color += pair + pair + pair;
  return color;
}*/


var selectedObjs = [];


//var raycaster = new THREE.Raycaster();
//var mouse = new THREE.Vector2();

let targetCamera = {
		update: false
	};

function render() {
	requestAnimationFrame(render);
	TWEEN.update();
	renderer.render( scene, camera );

	//console.log(raycaster);

	//console.log(cubeTexture);

	/*raycaster.setFromCamera( mouse, camera );

	for ( var i = 0; i < selectedObjs.length; i++ ) {

		selectedObjs[ i ].object.material.color.set( 0x776147 );

	}

	var intersects = raycaster.intersectObjects( scene.children );

	selectedObjs = [];

	for ( var i = 0; i < 1; i++ ) {

		var obj = intersects[i];

		if(obj && obj.object.name.indexOf('circle') > -1){

			selectedObjs.push(intersects[i]);

			intersects[ i ].object.material.color.set( 0xff9900 );
		}

	}*/

	// 

	// update the picking ray with the camera and mouse position
	/*

	// calculate objects intersecting the picking ray
	

	renderer.render( scene, camera );*/


	/*if(targetCamera.update){
		let p = targetCamera.position,
			t = targetCamera.target,
			cp = cloneObj3(camera.position),
			ct = cloneObj3(controls.target);

		Object.entries(cp).forEach(([k,v])=>{
			cp[k] -= (v - p[k]) / 10;
		});
		Object.entries(cp).forEach(([k,v])=>{
			ct[k] -= (v - t[k]) / 10;
		});

		//console.log(cp, ct);

		camera.position.set(cp.x, cp.y, cp.z);
		controls.target.set(ct.x, ct.y, ct.z);
		controls.update();
	}*/

}



/*function cloneObj3(obj){
	return {
		x: obj.x,
		y: obj.y,
		z: obj.z
	}
}*/



/*function onMouseMove( event ) {

	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components

	mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
	mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

}

window.addEventListener( 'mousemove', onMouseMove, false );*/

var plight = new THREE.PointLight( 0xffffff, 1, 90 );
plight.position.set( 0, 0, 0 );
plight.castShadow = true;

//plight.position = new THREE.Vector3(0,0,10);
scene.add( plight );

render();

function focusOnObject(obj){
	controls.enabled = false;
    var duration = 800;
    var position = new THREE.Vector3().copy(camera.position);
    var targetPosition = new THREE.Vector3();
    targetPosition.setFromMatrixPosition( obj.matrixWorld );

    targetPosition = getCircPoint( targetPosition, 100 );

    var lookAt = new THREE.Vector3().copy(controls.target);
    var targetLookAt = new THREE.Vector3();
    targetLookAt.setFromMatrixPosition( obj.matrixWorld );

    var tween = new TWEEN.Tween(position)
    	.delay(duration)
        .to(targetPosition, duration*2)
        .easing( TWEEN.Easing.Cubic.InOut )
        .onUpdate(function () {
            camera.position.copy(position);
        })
        .onComplete(function () {
            camera.position.copy( targetPosition );
            controls.enabled = true;
        })
        .start();

    var tween2 = new TWEEN.Tween(lookAt)
        .to(targetLookAt, duration*3)
        .easing( TWEEN.Easing.Cubic.InOut )
        .onUpdate(function () {
        	controls.target.set(lookAt.x, lookAt.y, lookAt.z);
        	controls.update();
        })
        .onComplete(function () {
        	controls.target.set(targetLookAt.x, targetLookAt.y, targetLookAt.z);
            //controls.update();
        })
        .start();
}

function getCircPoint(p2,d){
	var length = Math.sqrt( p2.x * p2.x + p2.y * p2.y + p2.z * p2.z);
	return new THREE.Vector3(d * p2.x/length, d * p2.y/length, d * p2.z/length );
}

/*document.onkeydown = checkKey;

function checkKey(e) {

    e = e || window.event;

    let num = Number(e.keyCode);

    if(num && num >= 48 && num <= 57){
    	num -= 48;
    	e.stopPropagation();
    	var obj = scene.getObjectByName( "circle-" + num.toString() );
    	focusOnObject(obj);
    }
}*/